import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpIconButtonComponent from './adpIconButton.component';

let adpIconButtonModule = angular.module('adpIconButton', [
  uiRouter
])

.component('adpIconButton', adpIconButtonComponent)

.name;

export default adpIconButtonModule;



// WEBPACK FOOTER //
// ./src/app/components/adpIconButton/adpIconButton.js